import * as e from "@shared-ui/localization-context";
import * as t from "react";
import * as a from "tslib";
import * as r from "uitk-react-icons";
import * as i from "uitk-react-utils";
var s = {
    197: () => {}
  },
  n = {};
function l(e) {
  var t = n[e];
  if (void 0 !== t) return t.exports;
  var a = n[e] = {
    exports: {}
  };
  return s[e](a, a.exports, l), a.exports;
}
l.n = e => {
  var t = e && e.__esModule ? () => e.default : () => e;
  return l.d(t, {
    a: t
  }), t;
}, l.d = (e, t) => {
  for (var a in t) l.o(t, a) && !l.o(e, a) && Object.defineProperty(e, a, {
    enumerable: !0,
    get: t[a]
  });
}, l.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), l.p = e + "../../../";
})();
var o = {};
(() => {
  l.d(o, {
    D: () => C
  });
  const s = (n = {
    useLocalization: () => e.useLocalization
  }, c = {}, l.d(c, n), c);
  var n, c;
  const d = (e => {
      var t = {};
      return l.d(t, e), t;
    })({
      Children: () => t.Children,
      Component: () => t.Component,
      Fragment: () => t.Fragment,
      createElement: () => t.createElement,
      createRef: () => t.createRef,
      isValidElement: () => t.isValidElement,
      useEffect: () => t.useEffect,
      useState: () => t.useState
    }),
    u = (e => {
      var t = {};
      return l.d(t, e), t;
    })({
      __assign: () => a.__assign,
      __extends: () => a.__extends
    }),
    m = (e => {
      var t = {};
      return l.d(t, e), t;
    })({
      UitkIcon: () => r.UitkIcon,
      UitkIconSize: () => r.UitkIconSize
    }),
    p = (e => {
      var t = {};
      return l.d(t, e), t;
    })({
      UitkContextWrapper: () => i.UitkContextWrapper,
      classNames: () => i.classNames
    });
  var h = l(197),
    f = l.n(h),
    b = p.classNames.bind(f()),
    y = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, u.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.id,
          a = e.label,
          r = e.className,
          i = b("uitk-field-label", r);
        return d.createElement("label", {
          htmlFor: t,
          className: i
        }, a);
      }, t.displayName = "UitkFieldLabel", t;
    }(d.Component),
    v = p.classNames.bind(f()),
    k = function (e) {
      var t = e.className,
        a = e.message,
        r = e.id,
        i = e.type,
        s = v("uitk-field-message", "uitk-field-message-".concat(i), "uitk-".concat(i, "-message"), t);
      return d.createElement("div", {
        className: s,
        id: "".concat(r, "-").concat(i)
      }, a);
    },
    x = p.classNames.bind(f()),
    E = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, u.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.className,
          a = e.labelClassName,
          r = e.label,
          i = e.instruction,
          s = e.invalid,
          n = e.hasFloatedLabel,
          l = e.icon,
          o = e.hasAutofill,
          c = e.hasBorder,
          h = e.hasVisibleLabel,
          f = e.children,
          b = e.required,
          v = this.props,
          E = v.id,
          N = v.disabled,
          g = v.placeholder,
          C = v.readOnly,
          _ = x("uitk-field", t, {
            "has-autofill": o,
            "has-floatedLabel-label": n,
            "has-icon": l,
            "has-no-border": !c,
            "has-no-visible-label": !h,
            "has-placeholder": !!(null == g ? void 0 : g.trim()),
            "has-textarea": d.Children.toArray(f).some(function (e) {
              return !("textarea" !== (null == e ? void 0 : e.type));
            }),
            "is-disabled": N,
            "is-invalid": s,
            "is-readonly": C,
            "is-required": b
          }),
          L = [];
        a && L.push(a), h && g || L.push("is-visually-hidden");
        var U = {
            className: L.join(" "),
            id: E,
            label: r,
            placeholder: g
          },
          F = function (e, t) {
            var a;
            return e && ("string" == typeof e && (a = d.createElement(k, {
              id: E,
              message: e,
              type: t
            })), "object" == typeof e && (a = d.createElement("div", {
              className: x("uitk-field-messages")
            }, e.primary && d.createElement(k, {
              className: x("uitk-field-message-primary"),
              id: E,
              message: e.primary,
              type: t
            }), e.secondary && d.createElement(k, {
              className: x("uitk-field-message-secondary"),
              id: E,
              message: e.secondary,
              type: t
            })))), a;
          };
        return d.createElement(p.UitkContextWrapper, null, function (e, t) {
          return d.createElement(d.Fragment, null, d.createElement("div", {
            className: _
          }, d.createElement(y, (0, u.__assign)({}, U)), f, !g && h && d.createElement("div", {
            className: x("uitk-field-label"),
            "aria-hidden": "true"
          }, r, b && (null == t ? void 0 : t.hasRequiredFieldIndicator) && d.createElement("span", {
            className: "uitk-field-required-asterisk",
            "aria-hidden": "true"
          }, " ", "*")), l && d.createElement(m.UitkIcon, {
            className: x("uitk-field-icon"),
            name: l
          })), s && F(s, "error"), i && F(i, "instruction"));
        });
      }, t.displayName = "UitkField", t.defaultProps = {
        hasBorder: !0,
        hasFloatedLabel: !0,
        hasVisibleLabel: !0
      }, t;
    }(d.Component);
  const N = l.p + "./styles/egds-search-experience-typeahead-custom-text-input.css",
    g = p.classNames.bind(N),
    C = e => {
      const {
          hasClearButton: t = !1,
          required: a = !1,
          value: r = "",
          domRef: i = d.createRef(),
          handleClear: n,
          onChange: l,
          id: o,
          name: c,
          children: u,
          label: p,
          hasBorder: h,
          hasFloatedLabel: f,
          hasVisibleLabel: b = !1,
          icon: y,
          instruction: v,
          invalid: k,
          placeholder: x,
          disabled: N,
          readOnly: C,
          predictiveText: _,
          ...L
        } = e,
        U = (0, s.useLocalization)(),
        [F, I] = d.useState(_);
      d.useEffect(() => {
        I(_);
      }, [_, F]);
      const z = t && !!r,
        q = {
          labelClassName: g(z && "has-typeahead-custom-text-input-cta"),
          disabled: N,
          hasBorder: h,
          hasFloatedLabel: f,
          hasVisibleLabel: b,
          icon: y,
          id: o,
          instruction: v,
          invalid: k,
          label: p,
          placeholder: x,
          readOnly: C,
          required: a
        },
        O = g("uitk-field-input", z && "has-typeahead-custom-text-input-cta", "typeahead-custom-text-input"),
        S = (() => {
          if (d.isValidElement(p)) {
            const e = p.props;
            return e?.children ?? "";
          }
          return p;
        })(),
        V = U.formatText("clear"),
        T = z ? [V, S].join(" ") : "";
      return d.createElement(E, {
        ...q
      }, d.createElement("input", {
        ...L,
        value: r,
        onChange: l,
        className: O,
        "aria-describedby": k ? `${o}-error` : void 0,
        placeholder: x,
        ref: i,
        id: o,
        "aria-required": a,
        "aria-invalid": !!k,
        type: "text"
      }), u, F && d.createElement("input", {
        ...L,
        className: g("predictive-text", "uitk-field-input", z && "has-typeahead-custom-text-input-cta", "typeahead-custom-text-input"),
        value: F,
        readOnly: !0
      }), z && d.createElement("button", {
        className: g("uitk-clear-button", "typeahead-custom-text-input-cta"),
        onClick: () => {
          l?.({
            target: {
              value: "",
              name: c
            }
          }), i?.current?.focus(), n?.(), I("");
        },
        type: "button"
      }, d.createElement(m.UitkIcon, {
        name: "cancel",
        size: m.UitkIconSize.SMALL,
        title: T,
        id: `${o}-clear-input-button`
      })));
    };
  C.displayName = "TypeaheadCustomTextInput";
})();
var c = o.D;
export { c as TypeaheadCustomTextInput };